class ArchiveMapsAddon {

    //
    //  ArchiveMapsAddon Documentatie
    //
    //  - Maakt gebruik van archive controler om data op te halen
    //  - Maakt dus ook gebuik van dezelfde filters en zoekopdrachten
    //
    //  1. Registreer de Googlemaps library met de googleapikey
    //  2. Registreer de betreffende archive controler
    //  3. (optioneel) set de style via een global var of via de functie set_style
    //  4. (optioneel) Gebruik callbacks (ondersteund standaard functie per event)
    //

    constructor() {
      this.version = 1.0;               // versiebeheer van script
      this.map_container = null;        // map-container, html-element
      this.map = null;                  // map, object
      this.markers = [];                // markers, objects
      this.cluster_marker_icon = null;
      this.marker_icon = null;
      this.archive_controler = null;
      this.marker_clusterer = null;
      this.active_infowindow = null;
      this.settings = {
        fullscreenControl: true,
        mapTypeControl: true,
        streetViewControl: false,
        zoomControl: true,
        zoomControlOptions: { position: 9 },
        maxZoom : 14,
        keyboardShortcuts: true,
        clickableIcons: true,
        styles: null,
        zoom: 8,
        center: { lat: 53.20139, lng: 5.80859}
      }
    }

    // Config
    set_style( _array ) {
      this.settings.styles = _array
    }

    set_cluster_marker_icon( _marker ) {
      this.cluster_marker_icon = _marker
    }

    set_marker_icon( _marker ) {
      this.marker_icon = _marker
    }

    settings(_name, value ) {
      this.settings[_name] = value;
    }

    // Register elements

    register_map_container( _el ) {
      this.map_container = _el;
    }

    register_self_loading_classname( _classname ) {
      this.self_loading_classname = _classname;
    }

    register_archive_controler( _archive_controler ) {
      this.archive_controler = _archive_controler
      this.archive_controler.on('doing-ajax', this.update_maps.bind(this))
    }

    // // Callbacks
    // on( _eventname, _callback_function ) {
    //   if( !(typeof _callback_function == 'function') ) { console.log('callback mist functie'); return; }
    //   if( !this.callbacks.hasOwnProperty(_eventname )){ console.log('onbekend event voor callback'); return; }
    //   this.callbacks[_eventname] = _callback_function;
    // }

    // Create / Render maps

    init( source_container ) {

      var that = this;

      if( source_container == undefined ) source_container = that.map_container

      var marker_elements = source_container.querySelectorAll('.marker'); // markers, html-elements

      that.map = new google.maps.Map(that.map_container, that.settings);

      marker_elements.forEach( function(marker_element) {


        var settings = JSON.parse( marker_element.getAttribute('data-settings'));
        var latlng = new google.maps.LatLng(settings.lat, settings.lng);
        var marker;

        var marker_settings = {
          position : latlng,
          map : that.map,
          label: '',
          zIndex : 1,
        };

        if( that.marker_style !== null ) {
          marker_settings['icon'] = that.marker_icon
        }

        marker = new google.maps.Marker(marker_settings);
        marker.settings = settings;

        // Check for custom marker click
        // if( that.settings && that.settings['markerClick'] ) {
        //   google.maps.event.addListener(marker, 'click', function (e) {
        //     that.markerClick(marker, _marker); // class
        //     that.callback('markerClick', that, marker, _marker); // settings
        //   });
        // }

        that.markers.push(marker);

        // Check for infowindow
        if( marker_element.innerHTML != '' ) {
          var infowindow = new google.maps.InfoWindow({
            content: marker_element.innerHTML
          });

          google.maps.event.addListener(marker, 'click', function (e) {
            if (that.active_infowindow != null ) 
              that.active_infowindow.close();
            that.active_infowindow = infowindow;
            infowindow.open(that, marker);
          });
        }

        // center is friesland

        // var bounds = new google.maps.LatLngBounds();
        // that.markers.forEach( function(_marker) {
        //   var latlng = new google.maps.LatLng(_marker.position.lat(), _marker.position.lng());
        //   bounds.extend(latlng);
        // });
        // that.map.setCenter(bounds.getCenter());
        // that.map.fitBounds(bounds); //that.map.setZoom(11);

      });

      var markerclusterer_settings = {
        map : that.map,
        markers: that.markers,
        algorithmOptions: {
          maxZoom : 12
        }
        //renderer: that.custom_renderer
      };

      if( that.cluster_marker_style !== null ) {
        const custom_renderer = new markerClusterer.DefaultRenderer()
          custom_renderer.render = that.customClusterRenderer.bind(that)
          markerclusterer_settings.renderer = custom_renderer
      }

      that.marker_clusterer = new markerClusterer.MarkerClusterer(markerclusterer_settings);
    }

   customClusterRenderer({ count, position }, stats, map) {
      return new google.maps.Marker({
        label: {
          text: String(count),
          color: "white",
          fontSize: "10px"
        },
        position,
        icon: this.cluster_marker_icon,
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      })
    }

    update_maps(data, page, archive_controler) {

      // Verwijder alle markers en plaats opnieuw
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
      this.marker_clusterer.clearMarkers();
      this.marker_clusterer = null;

      // Default Ajax afhandeling
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(data, "text/html");
      const new_map_container = htmlDoc.getElementById( this.map_container.id );
      this.init(new_map_container);

    }

}